import { useQuery } from "./useApi.js";
import { docParsing, type ParsingJobsFilters } from "../api/docParsing.service.js";

export function useParsingJobs(filters: ParsingJobsFilters) {
  return useQuery(
    () => docParsing.listResults(filters),
    [
      filters.status,
      filters.search,
      filters.limit,
      filters.offset,
      filters.edition,
      filters.publicationId,
      filters.regionId,
      filters.practiceAreaId,
      filters.editionId,
      filters.rankingEntityId,
      filters.bpaId,
      filters.taxonomy,
      filters.emptyHead,
      filters.emptyClients,
      filters.emptyContacts,
      filters.emptyMatters,
      filters.barReview,
      filters.barTemplate,
      filters.attention,
      filters.olderThanMinutes,
    ],
  );
}
